import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import ModalContext from 'contexts/ModalContext'
import { rem } from 'polished'
import { useCallback, useContext } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import ExperienceGiveAsGiftInfoModal from './ExperienceGiveAsGiftInfoModal'
import useTrackExperienceOfferEvent from 'contexts/support/useTrackExperienceOfferEvent'
import LineGiftIcon from 'LuxKit/Icons/line/LineGiftIcon'

const IconText = styled(Clickable)`
  display: flex;
  align-items: center;

  > * + * {
    margin-inline-start: ${rem(8)};
  }
`

interface Props {
  experience: App.ExperienceOffer
  onSupportEmailClick?: () => void
  onSupportNumberClick?: () => void
}

function ExperienceGiveAsGiftInfoText(props: Props) {
  const { experience, onSupportEmailClick, onSupportNumberClick } = props
  const intl = useIntl()
  const showModal = useContext(ModalContext)
  const trackEvent = useTrackExperienceOfferEvent()

  const handleClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    e.preventDefault()
    showModal(<ExperienceGiveAsGiftInfoModal
      experience={experience}
      onSupportEmailClick={onSupportEmailClick}
      onSupportNumberClick={onSupportNumberClick}
    />)
    trackEvent('GIFTING_AVAILABLE_CLICKED')
  }, [experience, showModal, trackEvent, onSupportEmailClick, onSupportNumberClick])

  return (
    <IconText onClick={handleClick}>
      <LineGiftIcon colour="highlight-primary-dark" size="S" />
      <BodyText colour="highlight-primary-dark" variant="medium" weight="bold">
        {intl.formatMessage({
          id: 'ftmEe3J5-kAj3jdUH-o3',
          defaultMessage: 'Gifting available',
        })}
      </BodyText>
      <LineInfoCircleIcon colour="normal-contrast" size="S" />
    </IconText>
  )
}

export default ExperienceGiveAsGiftInfoText
